import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { eventApi } from '../../../core/api/rtk-query/event.api';
import { getDayjsInGMT } from '../../../utils/dayjs.utils';
import { CreateEventModal } from './CreateEventModal';
import { EventDetailsModal } from './EventDetailsModal';
import { ResultsModal } from './ResultsModal';
import { DeleteEventConfirm } from './DeleteEventConfirm';

const Wrap = styled.div`display:grid; gap:16px;`;
const Toolbar = styled.div`display:flex; gap:8px; align-items:center; flex-wrap:wrap;`;
const Input = styled.input`padding:10px 12px; border-radius:10px; border:1px solid #dbe3f6; background:#fff; color:#0b1221;`;
const Select = styled.select`padding:10px 12px; border-radius:10px; border:1px solid #dbe3f6; background:#fff; color:#0b1221;`;
const Btn = styled.button`background:#fff; border:1px solid #dbe3f6; color:#0b1221; padding:8px 12px; border-radius:10px; cursor:pointer;`;

const Grid = styled.div`
  display:grid; gap:12px; grid-template-columns: 1fr 1fr; align-items:start;
  @media (max-width: 1200px){ grid-template-columns: 1fr; }
`;

const Card = styled.div`
  background:#fff; border-radius:12px; padding:16px; box-shadow:0 8px 24px rgba(0,0,0,.06); border:1px solid #e5e8f0;
  display:grid; gap:8px;
`;
const Row = styled.div`display:flex; gap:8px; align-items:center;`;
const Tag = styled.span`font-size:12px; padding:2px 8px; border-radius:999px; background:#f1f4ff; color:#0b68fe; border:1px solid #d9e3ff;`;

export const AdminEventsPage = () => {
  const { data: events, error, isLoading } = eventApi.useGetEventsQuery();
  const [status, setStatus] = useState<'all'|'active'|'finished'>('all');
  const [type, setType] = useState<'all'|'Homework'|'Contest'|'Milestone'|'Exam'>('all');
  const [search, setSearch] = useState('');
  const [createOpen, setCreateOpen] = useState(false);
  const [detailsEvent, setDetailsEvent] = useState<string|undefined>();
  const [resultsEvent, setResultsEvent] = useState<string|undefined>();
  const [removeEvent, setRemoveEvent] = useState<string|undefined>();

  const filtered = useMemo(()=> (events||[]).filter(e => {
    const now = Date.now();
    const isActive = new Date(e.endTime).getTime() > now;
    if (status==='active' && !isActive) return false;
    if (status==='finished' && isActive) return false;
    if (type!=='all' && e.type!==type) return false;
    if (search && !e.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  }).sort((a,b)=> new Date(b.startTime).getTime() - new Date(a.startTime).getTime()), [events, status, type, search]);

  return (
    <Wrap>
      <Toolbar>
        <h2 style={{margin:0}}>Мероприятия</h2>
        <Select value={status} onChange={e=> setStatus(e.target.value as any)}>
          <option value="all">Все</option>
          <option value="active">Активные</option>
          <option value="finished">Завершённые</option>
        </Select>
        <Select value={type} onChange={e=> setType(e.target.value as any)}>
          <option value="all">Тип: Все</option>
          <option value="Homework">Домашка</option>
          <option value="Contest">Контест</option>
          <option value="Milestone">Мильстоун</option>
          <option value="Exam">Экзамен</option>
        </Select>
        <div style={{marginLeft:'auto', display:'flex', gap:8}}>
          <Input placeholder="Поиск…" value={search} onChange={e=> setSearch(e.target.value)} />
          <Btn onClick={()=> setCreateOpen(true)}>Создать мероприятие</Btn>
        </div>
      </Toolbar>

      {error && (
        <div style={{background:'#fff0f0', border:'1px solid #ffd0d0', color:'#900', padding:12, borderRadius:8}}>
          Ошибка загрузки мероприятий: {typeof error === 'object' ? JSON.stringify(error) : String(error)}
        </div>
      )}
      <Grid>
        {filtered.map(e => {
          const from = getDayjsInGMT(e.startTime).format('DD.MM.YYYY, HH:mm:ss');
          const to = getDayjsInGMT(e.endTime).format('DD.MM.YYYY, HH:mm:ss');
          return (
            <Card key={e.id}>
              <Row style={{justifyContent:'space-between'}}>
                <div style={{fontWeight:700, cursor:'pointer'}} onClick={()=> setDetailsEvent(e.id)}>{e.name}</div>
                <Row>
                  <Tag>{(e.type||'').toLowerCase()}</Tag>
                </Row>
              </Row>
              <div style={{color:'#667'}}>{from} — {to} • мин. балл {e.minimumPointsToPass}</div>
              <div style={{color:'#667'}}>{e.description}</div>
              <Row style={{gap:8, justifyContent:'flex-end'}}>
                <Btn onClick={()=> setDetailsEvent(e.id)}>Изменить</Btn>
                <Btn onClick={()=> setResultsEvent(e.id)}>Результаты</Btn>
                <Btn onClick={()=> setRemoveEvent(e.id)}>Удалить</Btn>
              </Row>
            </Card>
          );
        })}
        {!isLoading && filtered.length === 0 && !error && (
          <div style={{gridColumn:'1 / -1', color:'#667'}}>Мероприятий нет.</div>
        )}
      </Grid>
      <CreateEventModal open={createOpen} onClose={()=> setCreateOpen(false)} />
      {detailsEvent && <EventDetailsModal eventId={detailsEvent} onClose={()=> setDetailsEvent(undefined)} />}
      {resultsEvent && <ResultsModal eventId={resultsEvent} onClose={()=> setResultsEvent(undefined)} />}
      {removeEvent && <DeleteEventConfirm id={removeEvent} onClose={()=> setRemoveEvent(undefined)} />}
    </Wrap>
  );
};


